<div class="container">
  <div class="title">{{ useTitle ? measurement.title : measurement.shortTitle }}</div>
  <div class="text">{{ measurement.text }}</div>
</div>
